// Central Firm & Multi-Tenancy Helper for PartyFrontend

export const getFirmId = () => {
  try {
    const authUser = localStorage.getItem("authUser");
    if (authUser) {
      const parsed = JSON.parse(authUser);
      return parsed.FirmId || parsed.F_FirmMaster || 1;
    }
  } catch (e) {
    console.warn("Error reading firmId from authUser:", e);
  }
  return 1;
};

export const getFirmDetails = () => {
  try {
    const firmProfile = localStorage.getItem("firmProfile");
    if (firmProfile) {
      return JSON.parse(firmProfile);
    }
    const authUser = localStorage.getItem("authUser");
    if (authUser) {
      return JSON.parse(authUser);
    }
  } catch (e) {
    console.warn("Error reading firm details:", e);
  }
  return null;
};

export const getFirmName = () => {
  try {
    const firmProfile = localStorage.getItem("firmProfile");
    if (firmProfile) {
      const parsed = JSON.parse(firmProfile);
      const name = parsed.FirmName || parsed.firmName;
      if (name && name !== "Default Firm") return name;
    }
    const authUser = localStorage.getItem("authUser");
    if (authUser) {
      const parsed = JSON.parse(authUser);
      const name = parsed.FirmName || parsed.firmName;
      if (name && name !== "Default Firm") return name;
    }
    const firmSub = localStorage.getItem("firmSubscription");
    if (firmSub) {
      const parsedSub = JSON.parse(firmSub);
      const name = parsedSub.firmName || parsedSub.FirmName;
      if (name && name !== "Default Firm") return name;
    }
  } catch (e) {
    console.warn("Error reading firmName:", e);
  }
  return "My Trading Firm";
};

export const getFirmAuthHeaders = () => {
  const firmId = getFirmId();
  const details = getFirmDetails();
  const headers = {
    "X-Firm-Id": firmId.toString(),
  };
  if (details && (details.token || details.accessToken)) {
    headers["Authorization"] = `Bearer ${details.token || details.accessToken}`;
  }
  return headers;
};
